import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
//import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js';
import GLTFMeshGpuInstancingExtension from './EXT_mesh_gpu_instancing.js'
import EventEmitter from './EventEmitter'
import gsap from 'gsap'

export default class Resources extends EventEmitter {
    items = {}
    toLoad = null
    loaded = 0

    constructor(sources) {
        super()

        // Options
        this.sources = sources

        // Setup
        this.toLoad = this.sources.length

        this.setLoaders()
        this.startLoading()
    }

    setLoaders() {
        const loadingEl = document.querySelector('.jsLoadingIndicator')
        const loadingValueEl = loadingEl.querySelector('.jsValue')

        this.loadingManager = new THREE.LoadingManager(
            // Loaded
            () => {
                console.log('Ready')
            },

            // Progress
            () => {
                const progress = Math.round((this.loaded / this.toLoad) * 100)
                loadingValueEl.innerHTML = progress

                if (progress === 100) {
                    gsap.timeline()
                        .to(loadingEl, { duration: 0.5, opacity: 0, ease: 'power2.inOut' })
                        .set(loadingEl, { display: 'none' })
                    ;
                }
            }
        )

        this.loaders = {}

        this.loaders.gltfLoader = new GLTFLoader(this.loadingManager)
        this.loaders.gltfLoader.register(parser => new GLTFMeshGpuInstancingExtension(parser))
        this.loaders.textureLoader = new THREE.TextureLoader(this.loadingManager)

        //Dracoloader
        this.loaders.dracoLoader = new DRACOLoader(this.loadingManager)
        this.loaders.dracoLoader.setDecoderPath('/draco/')
        this.loaders.gltfLoader.setDRACOLoader(this.loaders.dracoLoader)

        //Audio loader
        this.loaders.audioLoader = new THREE.AudioLoader()

        // //SVG loader
        // this.loaders.svgLoader = new SVGLoader()

    }

    startLoading() {
        // Load each source
        for (const source of this.sources) {
            if (source.type === 'gltfModel') {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if (source.type === 'texture') {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if (source.type === 'audio') {
                this.loaders.audioLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            // else if (source.type === 'svg') {
            //     this.loaders.svgLoader.load(
            //         source.path,
            //         (file) => {
            //             this.sourceLoaded(source, file)
            //         }
            //     )
            // }
        }
    }

    sourceLoaded(source, file) {
        this.items[source.name] = file
        this.loaded++

        if (this.loaded === this.toLoad) {
            this.trigger('ready')
        }
    }
}